import { formatValidQueryParamUrlCommaSeparated } from "utils/common";

import { emptySplitApi } from "./empty-split-api";
import {
  TemplateCategory,
  TemplateCategoryFilter,
  TemplateCategoryInput,
  TemplateCategoryResponse
} from "./types/template-categories.type";

export const DEFAULT_TEMPLATE_CATEGORY_QUERY = "{id,title,is_active,parent}";

const templateCategoriesApi = emptySplitApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getTemplateCategory: builder.query<TemplateCategory, number>({
      query: (id) => {
        return `/template-categories/${id}/`;
      },
      providesTags: ["TemplateCategories"]
    }),
    getTemplateCategories: builder.query<
      TemplateCategoryResponse,
      TemplateCategoryFilter
    >({
      query: (filters = {}) => {
        const filtersString = formatValidQueryParamUrlCommaSeparated({
          ...filters,
          search: filters.search
            ? encodeURIComponent(filters.search)
            : undefined,
          is_active: filters.is_active ?? true,
          query: filters?.query || DEFAULT_TEMPLATE_CATEGORY_QUERY
        });

        return `/template-categories/?${filtersString}`;
      },
      providesTags: ["TemplateCategories"]
    }),
    createTemplateCategory: builder.mutation<
      TemplateCategory,
      TemplateCategoryInput
    >({
      query: (input) => ({
        url: `/template-categories/`,
        method: "POST",
        body: input
      }),
      invalidatesTags: ["TemplateCategories"]
    }),
    updateTemplateCategory: builder.mutation<
      TemplateCategory,
      TemplateCategoryInput
    >({
      query: ({ id, ...rest }) => ({
        url: `/template-categories/${id}/`,
        method: "PATCH",
        body: rest
      }),
      invalidatesTags: ["TemplateCategories"]
    }),
    deleteTemplateCategory: builder.mutation<TemplateCategory, number>({
      query: (id) => ({
        url: `/template-categories/${id}/`,
        method: "DELETE"
      }),
      invalidatesTags: ["TemplateCategories"]
    })
  })
});

export const {
  useGetTemplateCategoryQuery,
  useGetTemplateCategoriesQuery,
  useCreateTemplateCategoryMutation,
  useUpdateTemplateCategoryMutation,
  useDeleteTemplateCategoryMutation
} = templateCategoriesApi;
